export interface Feature {
  title: string;
  description: string;
  icon: string;
  color: 'red' | 'blue' | 'emerald' | 'amber' | 'purple' | 'cyan';
  items?: string[];
  badge?: string;
}

export const defaultFeatures: Feature[] = [
  {
    title: 'Context Engineering',
    description: 'Automated mounting of private data sources directly into agent runtimes with role-based isolation.',
    icon: 'Database',
    color: 'red'
  },
  {
    title: 'Containerized Isolation',
    description: 'Every agent runs in a secure, resource-constrained Docker container with full lifecycle management.',
    icon: 'ShieldCheck',
    color: 'blue'
  },
  {
    title: 'Multi-Agent Delegation',
    description: 'Orchestrate complex workflows by delegating tasks between specialized agents with human-in-the-loop approvals.',
    icon: 'Users',
    color: 'emerald'
  },
  {
    title: 'Real-Time Monitoring',
    description: 'Live log streaming and resource metrics for every agentic process.',
    icon: 'Activity',
    color: 'amber'
  },
  {
    title: 'Marketplace Distribution',
    description: 'Publish, monetize, and discover containerized agentic applications in a global ecosystem.',
    icon: 'ShoppingBag',
    color: 'purple'
  },
  {
    title: 'Rapid Development',
    description: 'Build custom agents in minutes using our integrated development environment and pre-built toolchains.',
    icon: 'Zap',
    color: 'cyan'
  }
];